<!---数据统计--->
<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="人员对账单" name="check">
        <checklist ref="checklist">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="110">
              <template slot-scope="{row}">
                <el-button type="text" @click="details(row)">查看</el-button>
                <el-button type="text" @click="reBuild(row)">重新生成</el-button>
              </template>
            </el-table-column>
          </template>
        </checklist>
      </el-tab-pane>
      <el-tab-pane label="人员对账明细" name="details">
        <checkdetails ref="detailslist" />
      </el-tab-pane>
      <el-tab-pane label="营业网点汇总表" name="building">
        <buildinglist ref="buildinglist">
          <template slot="toolbar-right">
            <el-button type="primary" @click="onExport">导出</el-button>
          </template>
        </buildinglist>
      </el-tab-pane>
      <el-tab-pane label="班次消费表" name="shift">
        <shiftlist ref="shiftlist">
          <template slot="toolbar-right">
            <el-button type="primary" @click="onExport">导出</el-button>
          </template>
        </shiftlist>
      </el-tab-pane>
      <el-tab-pane label="窗口汇总表" name="window">
        <windowlist ref="windowlist">
          <template slot="toolbar-right">
            <el-button type="primary" @click="onExport">导出</el-button>
          </template>
        </windowlist>
      </el-tab-pane>
      <el-tab-pane label="窗口机明细表" name="windowdetail">
        <windowdetaillist ref="windowdetaillist">
          <template slot="toolbar-right">
            <el-button type="primary" @click="onExport">导出</el-button>
          </template>
        </windowdetaillist>
      </el-tab-pane>
    </el-tabs>
    <check-dialog ref="checkDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import checklist from "@/components/xf/statistics/checklist/list";
import checkDialog from "@/components/xf/statistics/checklist/editDialog";
import detailsDialog from "@/components/xf/statistics/checklist/detailsDialog";
import checkdetails from "@/components/xf/statistics/checkdetails/list";
// import teacherDialog from "@/components/xf/statistics/teacher/refundDialog";
import buildinglist from "@/components/xf/statistics/buildinglist/list";
import shiftlist from "@/components/xf/statistics/shiftlist/list";
import windowlist from "@/components/xf/statistics/windowlist/list";
import windowdetaillist from "@/components/xf/statistics/windowdetail/list";

export default {
  name: "statistics",
  mixins: [curdMixins],
  components: {
    checklist,
    checkDialog,
    detailsDialog,
    checkdetails,
    buildinglist,
    shiftlist,
    windowlist,
    windowdetaillist,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      tabName: "check",
      device_api: require("@/api/cp/device").default,
      BuildingList: [],
    };
  },
  mounted() {
    this.device_api.getBuildings().then((res) => {
      if (res.Code == 0) this.BuildingList = res.Data;
    });
  },
  methods: {
    handleClick(e) {
      this.reload();
    },
    reload() {
      this.$refs[this.tabName + "list"].BuildingList = this.BuildingList;
      if (this.tabName != "details") {
        this.$refs[this.tabName + "list"].getData();
      }
    },
    create() {
      this.$refs.checkDialog.openCreate();
    },
    details(row) {
      this.$refs.detailsDialog.open().then((that) => {
        that.getData({ BillId: row.BillId });
      });
    },
    reBuild(row) {
      this.$confirm("确认重新生成吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.checklist.reBuild(row);
        })
        .catch(() => {});
    },
    delRows() {
      var rows = this.$refs.checklist.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.BillId;
          });
          this.$refs.checklist.delRange(ids);
        })
        .catch(() => {});
    },
    onExport() {
      this.$refs[this.tabName + "list"].onExport();
    },
  },
};
</script>